import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id EF3D6923-793B-410C-B349-90A6A338F06C
 * name flash
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/flash.svg
 * tags
 * - Weather 
 */
export const FlashIcon = createSvgIcon(<><path d="M7,2V13H10V22L17,10H13L17,2H7Z" /></>, 'FlashIcon');
export default FlashIcon